import React, { useState, useEffect } from "react";
import "./editpopup.css";

const EditPopup = ({ title, fields = {}, onSave, onClose }) => {
  const [values, setValues] = useState({
    facebook: "",
    instagram: "",
    tiktok: "",
    youtube: "",
    email: "",
    contactNumber: "",
    address: "",
    ...fields,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setValues({
      facebook: fields.facebook || "",
      instagram: fields.instagram || "",
      tiktok: fields.tiktok || "",
      youtube: fields.youtube || "",
      email: fields.email || "",
      contactNumber: fields.contactNumber || "",
    });
  }, [fields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    let tempErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex =
      /^(?:\+1\s?)?(?:\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;

    if (title === "Edit Email" && !emailRegex.test(values.email)) {
      tempErrors.email = "Invalid email format.";
    }

    if (
      title === "Edit Contact Number" &&
      !phoneRegex.test(values.contactNumber)
    ) {
      tempErrors.contactNumber = "Invalid phone number.";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const validateContactNumber = (contactNumber) => {
    const regex = /^[0-9]{10}$/;
    return regex.test(contactNumber);
  };

  const handleSave = () => {
    if (validate()) {
      onSave(values);
      onClose();
    }
  };

  return (
    <div className="edit-popup">
      <div className="edit-popup-content">
        <div className="edit-popup-header">
          <h2>{title}</h2>
        </div>
        <div className="edit-popup-body">
          {title === "Edit Email" ? (
            <div className="edit-popup-field">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={values.email}
                onChange={handleChange}
              />

              {errors.email && (
                <span className="error-text">{errors.email}</span>
              )}
            </div>
          ) : title === "Edit Contact Number" ? (
            <div className="edit-popup-field">
              <label>Contact Number</label>
              <input
                type="text"
                name="contactNumber"
                value={values.contactNumber}
                onChange={handleChange}
              />
              {errors.contactNumber && (
                <span className="error-text">{errors.contactNumber}</span>
              )}
            </div>
          ) : title === "Edit Address" ? (
            <div className="edit-popup-field">
              <label>Address</label>
              <input
                type="text"
                name="Address"
                value={values.address}
                onChange={handleChange}
              />
            </div>
          ) : (
            <>
              <div className="edit-popup-field">
                <label>Facebook</label>
                <input
                  type="text"
                  name="facebook"
                  value={values.facebook}
                  onChange={handleChange}
                />
              </div>
              <div className="edit-popup-field">
                <label>Instagram</label>
                <input
                  type="text"
                  name="instagram"
                  value={values.instagram}
                  onChange={handleChange}
                />
              </div>
              <div className="edit-popup-field">
                <label>TikTok</label>
                <input
                  type="text"
                  name="tiktok"
                  value={values.tiktok}
                  onChange={handleChange}
                />
              </div>
              <div className="edit-popup-field">
                <label>YouTube</label>
                <input
                  type="text"
                  name="youtube"
                  value={values.youtube}
                  onChange={handleChange}
                />
              </div>
            </>
          )}
        </div>
        <div className="edit-popup-footer">
          <button onClick={handleSave}>Save</button>
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPopup;
